import { FormControlLabel, FormGroup, Switch, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { BsExclamationDiamond, BsRecord2 } from "react-icons/bs";
import { useLocation, useNavigate } from "react-router-dom";
import { Get } from "../../../../../Request";
import { Day, sepJustMoney, ToDateJalali } from "../../../Function";
import CustomModal from "../../Modal/CustomModal";
import EditTimeTable from "../../TimeTable";

const ContractTimes = ({ times, role, order, updateAll, setUpdateAll, isAbsent, appModal }) => {
  const navigate = useNavigate()

  const [refundList, setRefundList] = useState();
  const [modal, setModal] = useState(false);
  const [reason, setReason] = useState();
  const [wage, setWage] = useState(false);

  useEffect(() => {
    Get({ url: "/refundsetting/getall", data: { item_id: times[0].item_id } }).then(data => {
      setRefundList(data)
    });
  }, []);

  const Renderststus = type => {
    switch (type) {
      case "used":
        return "منقضی شده";
      case "refund":
        return "استرداد شده";
      case "canceled":
        return "لغو شده";
      default:
        return "عدم پرداخت";
    }
  };

  const refundTicket = async (ticketId) => {

    let refundData = { contract_reserve_id: ticketId, type: "contract" };
    let isOk = false;

    if (role == "owner") {
      refundData.action = "canceled";
      refundData.wage_status = wage;
      refundData.reason = reason;
      isOk = true;
    }
    else {
      isOk = window.confirm("آیا بلیت مورد نظر استرداد شود ؟")
    }
    if (isOk) {
      Get({ url: "/reserve/refund", data: refundData, addRes: true }).then(data => {
        if (data.status == "Success") {
          role == "owner"
            ? toast.success("بلیت با موفقیت لغو شد")
            : toast.success("بلیت شما با موفقیت استرداد شد")

          setUpdateAll(updateAll + 1)
        }
      });
    }
  }

  const timeHandler = (ticket, isAdd) => {

    let isOk;
    if (isAdd) {
      isOk = window.confirm("بلیت مورد نظر اضافه شود ؟");
    }
    else if (times.length == 1) {
      isOk = window.confirm("در صورت حذف آخرین سانس، سفارش به طور کامل حذف خواهد شد !");
    }
    else {
      isOk = window.confirm("آیا بلیت مورد نظر حذف شود ؟");
    }

    const data = {
      order_id: isAdd ? order.order_id : ticket.order_id,
      timekey: isAdd ? ticket.id : ticket.reserve_keys.timekey,
      daykey: isAdd ? ticket.daykey : ticket.reserve_keys.daykey,
      action: isAdd ? "add" : "delete"
    }

    if (isOk) {
      Get({ url: "/contractreserve/edit", data: data, addRes: true }).then(data => {
        if (data.status == "Success") {

          if (isAdd)
            toast.success("بلیت  با موفقیت اضافه شد")
          else
            toast.success("بلیت  با موفقیت حذف شد")

          if (times.length == 1) {
            navigate(-1);
          }
          else {
            setUpdateAll(updateAll + 1)
          }
        }
      });
    }
  }

  return (
    <div style={{ marginBottom: "20px" }}>
      <div style={{ borderBottom: "1px solid red" }} className="mb-2 d-flex align-items-center justify-content-between">
        <h4 style={{ fontSize: "18px" }}>مشخصات بلیت ها</h4>
        {role == "owner" && order.model_order == "contractual_reservation_installments" && order.status == "waittopay" &&
          <button className="btn btn-primary"
            onClick={e => setModal({ visible: true, item_id: times[0].item_id, dataModal: "addTicket" })}
          >افزودن بلیت</button>
        }
      </div>
      <div className="row ">
        {!role == "owner" && !order.model_order == "contractual_reservation_installments" &&
          <div className="col-12 mb-3">
            <h5 className="mb-3">
              <BsExclamationDiamond size={25} className="mx-2 text-warning" />
              شرایط استرداد :
            </h5>
            {refundList && refundList.length > 0
              ? refundList.map(item => (
                <div key={item.id} className="mb-2 mr-3">
                  <BsRecord2 className="ml-2" />
                  میزان کسری
                  <span className="font-weight-bold">
                    {" " + (item.remaining_time) + " "}
                  </span>
                  ساعت قبل از شروع  :
                  <span className="font-weight-bold">
                    {" " + (item.percentage) + " "}
                    %
                  </span>
                </div>
              ))
              : <div className="mb-2 mr-3">
                <BsRecord2 className="ml-2" />
                شرایطی برای استرداد ثبت نشده است
              </div>
            }
          </div>
        }

        {times && times.map((item, index) => (
          <div key={item.id} className="col-sm-6 col-lg-4 col-xl-3 mb-2">
            <div className="bg-light rounded border shadow text-center p-3">

              <div>
                <span style={{ fontWeight: "500" }}>
                  {" "}
                  {Day(item.reserve_time.dayname)}{" "}
                </span>
                <span className="mx-1">
                  -
                </span>
                <span style={{ fontWeight: "500" }}>
                  {ToDateJalali(item.reserve_time.date)}{" "}
                </span>
              </div>
              <div>
                <span style={{ fontWeight: "500" }}> شروع : </span>{" "}
                <span style={{ fontWeight: "500" }}>
                  {item.reserve_time.start}{" "}
                </span>

                <span className="mx-1"> - </span>

                <span style={{ fontWeight: "500" }}> پایان : </span>{" "}
                <span style={{ fontWeight: "500" }}>
                  {item.reserve_time.end}{" "}
                </span>
              </div>
              <p>
                قیمت :
                {" " + (sepJustMoney(item.price)) + " "}
                تومان
              </p>

              {role == "owner"
                ? <>
                  <button className="btn btn-primary w-75 text-center d-flex mx-auto justify-content-center"
                    onClick={e => {
                      if (item.status == "waittopay") {
                        timeHandler(item)
                      }
                      else {
                        setModal({ visible: true, item_id: item.id, dataModal: "refund" })
                      }
                    }}>
                    {item.status == "waittopay" ? "حذف" : "لغو"}

                  </button>
                  {item.status != "active" && <div style={{ fontSize: "12px", marginTop: "10px" }}>
                    {Renderststus(item.status)}
                  </div>
                  }
                </>
                : item.status == "active"
                  ? <button className="btn btn-primary w-75 text-center d-flex mx-auto justify-content-center"
                    onClick={e => {
                      if (role == "manager") {
                        appModal()
                      }
                      else {
                        refundTicket(item.id)
                      }
                    }}>
                    {role == "manager" && (isAbsent ? "ثبت حضور" : "منقضی کردن ")}
                    {role == "user" && "استرداد"}
                  </button>
                  : <div className="btn btn-primary w-75 text-center d-flex mx-auto justify-content-center" style={{ opacity: "0.7" }}>
                    {Renderststus(item.status)}
                  </div>
              }

              {/* {item.status == "active"
                ? role == "owner"
                  ? <button className="btn btn-primary w-75 text-center d-flex mx-auto justify-content-center"
                    onClick={e => setModal({ visible: true, item_id: item.id, dataModal: "refund" })}>
                    لغو
                  </button>
                  : <button className="btn btn-primary w-75 text-center d-flex mx-auto justify-content-center"
                    onClick={e => refundTicket(item.id)}>
                    استرداد
                  </button>
                : order.model_order == "contractual_reservation_installments"
                  ?
                  <button className="btn btn-primary w-100 text-center d-flex mx-auto justify-content-center"
                    onClick={e => timeHandler(item)}>
                    حذف
                  </button>
                  :
                  <button className="btn btn-primary w-100 text-center d-flex mx-auto justify-content-center"
                    disabled>
                    بلیت لغو شده است
                  </button>

              } */}

            </div>
          </div>
        ))}

        {role == "owner" && (
          <>
            <CustomModal
              size={modal.dataModal == "addTicket" ? "xl" : 'md'}
              show={modal.visible}
              header={modal.dataModal == "addTicket" ? "افزودن بلیت" : "لغو بلیت"}
              handleClose={() => {
                setModal({ visible: false });
              }} >
              {modal.dataModal == "refund" &&
                <>
                  <div className={`mt-2 mb-3`}>
                    <TextField size="small" label="دلیل لغو" className="w-100"
                      onChange={(e) => setReason(e.target.value)} />
                  </div>

                  <div className="d-flex align-items-center my-3">
                    <p className="mb-0 ml-2 mr-4">کسر کارمزد از  حساب مجموعه</p>
                    <FormGroup>
                      <FormControlLabel size="sm" control={<Switch defaultChecked />} checked={wage}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setWage(true);
                          }
                          else {
                            setWage(false);
                          }
                        }} />
                    </FormGroup>
                  </div>

                  <button className="btn btn-primary px-4"
                    onClick={() => {
                      refundTicket(modal.item_id)
                      setModal({ visible: false });
                    }}
                    disabled={reason ? false : true}
                  >
                    ثبت
                  </button>
                </>
              }

              {modal.dataModal == "addTicket" &&
                <EditTimeTable
                  id={modal.item_id}
                  edit={{
                    status: true,
                    disabledDonItem: true,
                    method: (time, status) => {
                      if (status)
                        timeHandler(time, true)
                    },
                  }}
                />
              }

            </CustomModal>
          </>
        )}

      </div>
    </div >
  );
};

export default ContractTimes;
